import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  changePlanzoneLogo(
    credentials: Boundaries["changePlanzoneLogo"]["request"],
  ): void;
}

function useChangePlanzoneLogo(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isChangePlanzoneLogoRequestPending),
    isRequestSuccess: useSelector(selector.isChangePlanzoneLogoRequestSuccess),
    isRequestFailure: useSelector(selector.isChangePlanzoneLogoRequestFailure),
    changePlanzoneLogo: core.changePlanzoneLogo,
  };
}

export { useChangePlanzoneLogo };
